(function() {
    'use strict';

    angular.module('remitEventsApp').run(function($trace, $rootScope, $state, $templateCache, stateHandler, $location, $window, ENV, VERSION) {
        $rootScope.ENV = ENV;
        $rootScope.VERSION = VERSION;

        $trace.disable('TRANSITION');
        $state.defaultErrorHandler(function() {});

        stateHandler.initialize();

        $rootScope.back = function() {
            if ($rootScope.previousStateName === 'activate' || $state.get($rootScope.previousStateName) === null) {
                $state.go('main');
            } else {
                $state.go($rootScope.previousStateName, $rootScope.previousStateParams);
            }
        };

        $templateCache.put(
            '/scripts/components/uiblocker/angular-block-ui.ng.html',
            '<div class="block-ui-overlay" style="opacity:1"></div>' +
                '<div class="block-ui-message-container" aria-live="assertive" aria-atomic="true">' +
                '<div class="block-ui-message" ng-class="$_blockUiMessageClass">{{ state.message }}</div>' +
                '</div>'
        );

        $rootScope.$on('$routeChangeSuccess', function(event) {
          gtag('config', 'UA-51902929-20', {'page_path': $location.path()});
        });

    });
})();
